<ngx-select class="variables-dashboard"  [allowClear]="false" [items]="items" optionValueField="value" optionTextField="name"
    [(ngModel)]="variableSelected" placeholder="Variable" (select)="changeVariable($event)" dropDownMenuOtherClasses="variables-dashboard">

    <ng-template ngx-select-option-not-found let-input>
        "{{input}}" no encontrada
    </ng-template>

</ngx-select>